theme.counter__Number = (function () {
  class CounterNumber {
    constructor(section) {
      this.container = section;
      this.counterElements = this.container.querySelectorAll('.counter-stats__number');
      this.animated = false;
      this.init();
    }

    init() {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.animated) {
            this.startCounters();
            this.animated = true;
          }
        });
      }, { threshold: 0.2 });

      this.observer.observe(this.container);
    }

    startCounters() {
      this.counterElements.forEach((el) => {
        // Read the raw value, e.g. "5000+", "99%", "1500+", "100+"
        const raw = String(el.dataset.counter || '').trim();
        const anim = new CounterAnimation(el, raw);
        anim.start();
      });
    }

    onUnload() {
      if (this.observer) this.observer.disconnect();
    }
  }

  class CounterAnimation {
    constructor(element, rawTarget) {
      this.element = element;

      // Extract numeric part and suffix (anything after the number)
      // Matches "1234", "1234+", "99%", "123.5k+" (we ignore any non-digit suffix for counting)
      const m = String(rawTarget).match(/^(\d+(?:\.\d+)?)(.*)$/);
      const numericPart = m ? m[1] : '0';
      this.suffix = m ? m[2].trim() : '';

      this.targetNumber = parseFloat(numericPart) || 0;
      this.currentNumber = 0;

      // Smooth animation: ~100 steps
      this.increment = Math.ceil(this.targetNumber / 100) || 1;
      this.interval = 20; // ms
    }

    start() {
      const timer = setInterval(() => {
        this.currentNumber += this.increment;
        if (this.currentNumber >= this.targetNumber) {
          this.currentNumber = this.targetNumber;
          clearInterval(timer);
        }
        this.element.textContent = this.formatNumber(this.currentNumber) + this.suffix;
      }, this.interval);
    }

    formatNumber(num) {
      // Format 1500 -> 1.5K, 5000 -> 5.0K, keep integers under 1000 as-is
      if (num >= 1_000_000) {
        return (num / 1_000_000).toFixed(1) + 'M'; // keeps your style consistent
      } else if (num >= 1_000) {
        return (num / 1_000).toFixed(1) + 'K';
      }
      return String(Math.floor(num));
    }
  }

  return CounterNumber;
})();